export default "__VITE_ASSET__e06a40d3__"